import { render, staticRenderFns } from "./crossHair.vue?vue&type=template&id=4b4dc70d&scoped=true"
import script from "./crossHair.vue?vue&type=script&lang=js"
export * from "./crossHair.vue?vue&type=script&lang=js"
import style0 from "./crossHair.vue?vue&type=style&index=0&id=4b4dc70d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4dc70d",
  null
  
)

export default component.exports